<div class="modal-body">
    <img style="display: block; margin-left: auto; margin-right: auto; max-width: 10%;" src="assets/images/cinejoy/Agiletix/loadingSpinner.gif" />
</div>